<div class="ficha-cadastro-detalhe-cliente-caminhao-proprio-quitado">
  <form [formGroup]="form">
    <div class="form-group pb0">
      <span class="icon"></span>
      <div class="inputs field-group">
        <label class="ficha-cadastro-detalhe-cliente-caminhao-proprio-quitado_label">Caminhão Próprio Quitado?</label>
        <div class="switch-row field-group__pesados">
          <div class="switch-group">
            <app-switch
              #simVeiculoQuitado
              id="simVeiculoQuitado"
              (change)="setVeiculoQuitado($event)">
            </app-switch>
            <span class="radio-label">Sim</span>
          </div>

          <div class="switch-group switch-field">
            <app-switch
              #naoVeiculoQuitado
              id="naoVeiculoQuitado"
              (change)="setVeiculoQuitado($event)">
            </app-switch>
            <span class="radio-label">Não</span>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group pb0" [ngClass]="{'dn': !showDadosPreencher}">
      <span class="icon pesado-money"></span>
      <div class="inputs">
        <label for="seller-store">Banco Alienado</label>
        <select
          formControlName="banco"
          name="banco"
          class="form-control"
          required
          appShowErrorMessages
          requiredMessage="O campo Banco Alienado é obrigatório">
          <option value="" disabled hidden>Selecione...</option>
          <option *ngFor="let banco of bancos" [ngValue]="banco">
            {{ banco.codigo }} - {{ banco.descricao }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group pb0" [ngClass]="{'dn': !showDadosPreencher}">
      <span class="icon"></span>
      <div class="inputs ficha-cadastro-detalhe-cliente-caminhao-proprio-quitado_multi-input">
        <div class="field-left">
          <label for="cliente-renda-comprovada">Total de Parcelas</label>
          <input
              formControlName="totalParcela"
              name="valor-parcela"
              type="text"
              class="form-control"
              placeholder="000"
              maxlength="3"
              appOnlyNumberRestrictive
              required
              requiredMessage="O campo Total da Parcelas é obrigatório"
              appShowErrorMessages
          />
        </div>
        <div class="field-rigth">
          <label for="cliente-renda-comprovada">Valor da Parcela</label>
          <input
              formControlName="valorParcela"
              name="valor-parcela"
              type="text"
              class="form-control"
              placeholder="R$ 0.000,00"
              [maxLength]="15"
              required
              [prefix]="'R$'"
              mask-money
              appOnlyMoney
              requiredMessage="O campo Valor da Parcela é obrigatório"
              appOnlyDigitsLengthValidator
              appShowErrorMessages
          />
        </div>
      </div>
    </div>

    <div class="form-group" [ngClass]="{'dn': !showDadosPreencher}">
      <span class="icon"></span>
      <div class="inputs">
        <div class="field-left">
          <label for="cliente-renda-comprovada">Total de Parcelas Quitadas</label>
          <input
              formControlName="parcelasQuitada"
              name="parcela"
              type="text"
              class="form-control"
              placeholder="000"
              maxlength="3"
              appOnlyNumberRestrictive
              required
              requiredMessage="O campo Total de Parcelas Quitadas é obrigatório"
              appShowErrorMessages
          />
          <div class="text-danger" *ngIf="!isParcelasValid">
            Total de Parcelas Quitadas deve ser menor que o Total de Parcelas
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
